module.exports = __webpack_public_path__ + "media/notif5.e48a7fb6.wav";